import { createAction } from '@reduxjs/toolkit';

export const CONTACTS_SEARCH_BY_ACTION_TYPE = 'saga/contactsSearchBy';
export const contactsSearchByAction = createAction(CONTACTS_SEARCH_BY_ACTION_TYPE);
